const StartPage = () => import(/* webpackChunkName: "StartPage" */ "./pages/StartPage");
const SingleOrdersPage = () => import(/* webpackChunkName: "SingleOrdersPage" */ "./pages/SingleOrders");
const SingleOrders = () => import(/* webpackChunkName: "SingleOrders" */ "./pages/SingleOrders/SingleOrders");
const SingleOrder = () => import(/* webpackChunkName: "SingleOrder" */ "./pages/SingleOrders/SingleOrder");
const MasterAgreementsPage = () => import(/* webpackChunkName: "MasterAgreementsPage" */ "./pages/MasterAgreements");
const MasterAgreements = () =>
    import(/* webpackChunkName: "MasterAgreements" */ "./pages/MasterAgreements/MasterAgreements");
const MasterAgreement = () =>
    import(/* webpackChunkName: "MasterAgreement" */ "./pages/MasterAgreements/MasterAgreement");
const MasterAgreementUpdate = () =>
    import(/* webpackChunkName: "MasterAgreementUpdate" */ "./pages/MasterAgreements/MasterAgreementUpdate");
const MasterAgreementReview = () =>
    import(/* webpackChunkName: "MasterAgreementReview" */ "./pages/MasterAgreements/MasterAgreementReview");

const ServiceRequestsPage = () => import(/* webpackChunkName: "ServiceRequestsPage" */ "./pages/ServiceRequests");
const ServiceRequests = () =>
    import(/* webpackChunkName: "ServiceRequests" */ "./pages/ServiceRequests/ServiceRequests");
const ServiceRequest = () => import(/* webpackChunkName: "ServiceRequest" */ "./pages/ServiceRequests/ServiceRequest");

const SingleOrderUpdate = () =>
    import(/* webpackChunkName: "SingleOrderUpdate" */ "./pages/SingleOrders/SingleOrderUpdate");
const SingleOrderReview = () =>
    import(/* webpackChunkName: "SingleOrderReview" */ "./pages/SingleOrders/SingleOrderReview");

const pages = [
    {
        path: "/",
        redirect: "/start-page",
    },
    {
        path: "/start-page",
        name: "StartPage",
        component: StartPage,
    },
    {
        path: "/contracts",
        name: "Contracts",
        redirect: {
            name: "AllSingleOrders",
            path: "/contracts/single-orders",
        },
        component: SingleOrdersPage,
        children: [
            {
                path: "single-orders",
                name: "AllSingleOrders",
                component: SingleOrders,
            },
            {
                path: "master-agreements",
                name: "AllMasterAgreements",
                component: MasterAgreements,
            },
        ],
    },
    {
        path: "/single-orders",
        name: "SingleOrder",
        component: SingleOrdersPage,
        children: [
            {
                path: ":contractId",
                name: "SingleContract",
                component: SingleOrder,
                props: (route) => ({ contractId: route.params.contractId }),
            },
            {
                path: ":contractId/:requestId",
                name: "SingleOrderReview",
                component: SingleOrderReview,
                props: (route) => ({
                    contractId: route.params.contractId,
                    requestId: route.params.requestId
                }),
            },
            {
                path: ":contractId/update/master-data",
                name: "SingleOrderUpdateMasterData",
                component: SingleOrderUpdate,
                props: (route) => ({
                    contractId: route.params.contractId,
                    updateDataType: "master-data-update"
                }),
            },
            {
                path: ":contractId/update/billing-data",
                name: "SingleOrderUpdateBillingData",
                component: SingleOrderUpdate,
                props: (route) => ({
                    contractId: route.params.contractId,
                    updateDataType: "billing-data-update"
                }),
            },
        ],
    },
    {
        path: "/master-agreements",
        name: "MasterAgreements",
        component: MasterAgreementsPage,
        children: [
            {
                path: ":contractId",
                name: "MasterAgreement",
                component: MasterAgreement,
                props: (route) => ({ contractId: route.params.contractId }),
            },
            {
                path: ":contractId/:requestId",
                name: "MasterAgreementReview",
                component: MasterAgreementReview,
                props: (route) => ({
                    contractId: route.params.contractId,
                    requestId: route.params.requestId
                }),
            },
            {
                path: ":contractId/update/master-data",
                name: "MasterAgreementUpdateMasterData",
                component: MasterAgreementUpdate,
                props: (route) => ({
                    contractId: route.params.contractId,
                    updateDataType: "master-data-update"
                }),
            },
            {
                path: ":contractId/update/billing-data",
                name: "MasterAgreementUpdateBillingData",
                component: MasterAgreementUpdate,
                props: (route) => ({
                    contractId: route.params.contractId,
                    updateDataType: "billing-data-update"
                }),
            },
        ],
    },
    {
        path: "/service-requests",
        name: "ServiceRequests",
        component: ServiceRequestsPage,
        children: [
            {
                path: "",
                name: "AllServiceRequests",
                component: ServiceRequests,
            },
            {
                path: "new",
                name: "ServiceRequestNew",
                component: ServiceRequest,
            },
            {
                path: ":requestId",
                name: "ServiceRequest",
                component: ServiceRequest,
                props: (route) => ({ requestId: route.params.requestId }),
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: {
            name: "StartPage"
        },
    },
];

export { pages };
